import script from "./ProcessResultDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProcessResultDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ProcessResultDialog.vue?vue&type=style&index=0&id=4dfa0f82&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/data/workspace/PRD.standard_checktarget_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dfa0f82"]])

export default __exports__